import "./style.scss"
import ReactDOM from "react-dom/client"
import Scene from "./App"

const root = ReactDOM.createRoot(document.querySelector("#root"))

root.render(
  <>
    <Scene />
  </>
)
